import React, { useEffect, useState } from "react";
import Cart from "../Components/Layout/Cart/Cart";
import HeaderMinimal from "../Components/Layout/HeaderMinimal";
import { TbBuildingSkyscraper, TbClock, TbId, TbMapPin, TbMessage, TbTicket } from "react-icons/tb";
import ButtonsCheckout from "../Components/Layout/Cart/ButtonsCheckout";
import Button from "../Components/Form/Button";
import { useStoreContext } from "../Contexts/StoreContext";
import { useOrderTypeContext } from "../Contexts/OrderTypeContext";
import { useLoginContext } from "../Contexts/LoginContext";
import { ImSpinner8 } from "react-icons/im";
import { IMaskInput } from "react-imask";
import { formatAddressStore, isCpfValid } from '../Utils/Helpers'
import { formatCartId, formatCpf, formatCurrentAddress } from "../Utils/Formatters";
import CustomerService from "../Services/CustomerService";
import { useLayoutContext } from "../Contexts/LayoutContext";
import FormRegisterCustomerCard from "../Components/Form/FormRegisterCustomerCard";
import { MENU_PAY_ON_DELIVERY, MENU_PREPAID, METHOD_PAYMENT_TYPE_CARD_DELIVERY, METHOD_PAYMENT_TYPE_CARD_ONLINE, METHOD_PAYMENT_TYPE_GOOGLE_PAY, METHOD_PAYMENT_TYPE_MONEY, METHOD_PAYMENT_TYPE_PIX, METHOD_PAYMENT_TYPE_VOUCHER, METHOD_PAYMENT_TYPE_WALLET, ORDER_STATUS_AWAITING_PAYMENT } from "../Utils/Constants/Checkout";
import StoreService from "../Services/StoreService";
import OrderService from "../Services/OrderService";
import { useCheckoutContext } from "../Contexts/CheckoutContext";
import { useNavigate } from "react-router-dom";
import { useCartContext } from "../Contexts/CartContext";
import Modal from "../Components/Layout/Modal";
import Confirm, { CONFIRM_ICON_INVOICE } from "../Components/Layout/Confirm";
import { useCartHook } from "../Hooks/CartHook";
import { useStoreHook } from "../Hooks/StoreHook";
import CartEmpty from "../Components/Layout/Cart/CartEmpty";
import ButtonLink from "../Components/Form/ButtonLink";
import CardBoxCheckout from "../Components/Layout/CardBoxCheckout";
import { GooglePayParamsProps } from "../Components/Form/GooglePayButton";
import { HiXMark } from "react-icons/hi2";
import { MdOutlineTableRestaurant } from "react-icons/md";
import Badge from "../Components/Layout/Badge";
import Drawer from "../Components/Layout/Drawer";
import FormProfileCheckout from "../Components/Form/FormProfileCheckout";
import { ORDER_TYPE_ICONS, ORDER_TYPE_LABELS } from "../Utils/Constants/Service";
import { useTranslation } from "react-i18next";
import { TokenManager } from "../Services/TokenManager";
import CardBoxCheckoutMethod from "../Components/Layout/CardBoxCheckoutMethod";
import { TAKEOUT_OPTIONS_DINE_IN } from "../Utils/Constants/Order";
import CardBoxCheckoutTable from "../Components/Layout/CardBoxCheckoutTable";
import PaymentMethods from "../Components/Layout/Checkout/PaymentMethods";

const Checkout = () => {

    const { t } = useTranslation();
    const [showBoxPaymentMethod, setShowBoxPaymentMethod] = useState<boolean>(false);
    const [showStoreAddress, setShowStoreAddress] = useState<boolean>(false);
    const { company, setMainLoading, setMainLoadingIcon, setMainLoadingIconInfo, setMainLoadingIconError, setMainLoadingTitle, setMainLoadingMessage, setMainLoadingCloseButton, boxHeightMethodPayment } = useLayoutContext();
    const [observation, setObservation] = useState('');
    const [showInputObservation, setShowInputObservation] = useState(false);
    const [couponCode, setCouponCode] = useState('');
    const [couponCodeApplied, setCouponCodeApplied] = useState<boolean>(false);
    const [cpf, setCpf] = useState('');
    const [showInputCpf, setShowInputCpf] = useState(false);
    const [googlePayDataResponse, setGooglePayDataResponse] = useState<GooglePayParamsProps | null>(null);
    const [loadingGetCards, setLoadingGetCards] = useState<boolean>(true);
    const [labelBtnPay, setLabelBtnPay] = useState<string>('');
    const [customerCards, setCustomerCards] = useState<any>([]);
    const { currentStore, currentAddress, cashier, checkStoreOpen } = useStoreContext();
    const { orderType, getOrderTypeIdByName, isStoreCounter, isDelivery, isDinein, takeoutMode, setTakeoutMode, setShowTakeoutModeOptions } = useOrderTypeContext();
    const { user, setUser } = useLoginContext();
    const { setOrder, currentCard, setCurrentCard, paymentMethod, setPaymentMethod, currentMenuMethod, setCurrentMenuMethod, loadingListPaymentMethods, setLoadingListPaymentMethods, setMethodCardOnline, showRegisterCard, setShowRegisterCard } = useCheckoutContext();
    const { cartDisplay, setReturnToCheckout, currentCart, loadingCoupon, setShowConfirmTable } = useCartContext();
    const [showConfirmCancel, setShowConfirmCancel] = useState(false);
    const [showConfirmOrdersOpen, setShowConfirmOrdersOpen] = useState(false);
    const [isValidCouponCode, setIsValidCouponCode] = useState(false);
    const [cart, setCart] = useState<any>(null);
    const { cartFinished, applyCouponCode, removeCouponCode, checkOrdersOpen, handleUpdateCartTable } = useCartHook();
    const { loadCompanyInfo, loadStoreInfo, noOpenCashier, getActiveCart, storeIsOpen, getLinkToHome, loadTables } = useStoreHook();
    const navigate = useNavigate();
    const [prepaidMethod, setPrepaidMethod] = useState<any>(null);
    const [payOnDeliveryMethod, setPayOnDeliveryMethod] = useState<any>(null);
    const [prepaidList, setPrepaidList] = useState<any[]>([]);
    const [payOnDeliveryList, setPayOnDeliveryList] = useState<any[]>([]);
    const [isNewCardEnabled, setIsNewCardEnabled] = useState<boolean>(false);
    const [showFormProfile, setShowFormProfile] = useState(false);

    const goToOrderPlace = (order: any) => {
        navigate(`${getLinkToHome()}/order/${order.id}/placed`);
    }

    const goToHome = () => {
        navigate(getLinkToHome());
    }

    const handleCancel = () => {
        goToHome();
        setReturnToCheckout(false);
        setMainLoading(false);
    }

    const handleCoupon = () => {
        if (!couponCodeApplied) {
            if (isValidCouponCode) {
                applyCouponCode(couponCode).then((response: any) => {
                    if (response.cart) {
                        setCart(response.cart)
                    }
                });
            }
        } else {
            removeCouponCode(couponCode).then((response: any) => {
                if (response.cart) {
                    setCart(response.cart)
                }
            });
        }
    }

    useEffect(() => {
        loadCompanyInfo();

        if (currentStore) {
            loadStoreInfo(currentStore.id);
        }

        // Confirmando saída da página no botão de retorno do navegador
        const handlePopState = (event: PopStateEvent) => {
            event.preventDefault();
            setShowConfirmCancel(true);
        };
        window.addEventListener('popstate', handlePopState);
        window.history.pushState({}, '');
        return () => {
            window.removeEventListener('popstate', handlePopState);
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        setIsValidCouponCode(Boolean(couponCode && couponCode !== '#'))
    }, [couponCode]);

    useEffect(() => {
        const orderTypeId = Number(getOrderTypeIdByName(orderType));
        if (
            (isStoreCounter && !cartDisplay) 
            || (!isStoreCounter && !TokenManager.getToken()) 
            || (currentStore && !checkStoreOpen(orderTypeId))
        ) {
            goToHome();
        }

        setMethodCardOnline({
            type: METHOD_PAYMENT_TYPE_CARD_ONLINE,
            name: t('checkout.button_method_payment_card_label'),
            register: true
        });

        document.title = currentStore?.name || company?.name;

        if (currentStore) {
            if (isStoreCounter && !cashier) {
                noOpenCashier();
                handleCancel();
            }

            const loadListPaymentMethods = async () => {
                setLoadingListPaymentMethods(true);
                try {
                    const storeSevice = new StoreService(orderType);
                    const orderTypeId = Number(getOrderTypeIdByName(orderType));
                    const payload = {
                        store_id: currentStore?.id,
                        order_type: orderTypeId,
                    }
                    const data = await storeSevice.listPaymentMethods(payload);
                    if (Array.isArray(data)) {
                        //* prepaid
                        setPrepaidMethod(data.find(item => item.prepaid));
                        //* pay_on_delivery
                        setPayOnDeliveryMethod(data.find(item => "pay_on_delivery" in item));
                    }
                }
                catch (error) {}
                finally {
                    setLoadingListPaymentMethods(false);

                    if (!Boolean(takeoutMode) && isDinein && TokenManager.getToken()) {
                        setShowTakeoutModeOptions(true);
                    }
                }
            }
            loadListPaymentMethods();
            getCustomerCards();
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isStoreCounter]);

    useEffect(() => {
        if (currentCart) {
            setCart(currentCart);
            setCouponCode(currentCart.coupon_code);
            setCouponCodeApplied(currentCart.coupon_code);

            //* Validando dinein_table_enabled
            if (takeoutMode === TAKEOUT_OPTIONS_DINE_IN && currentStore.dinein_table_enabled) {
                if (!currentCart?.table) {
                    setShowConfirmTable(true);
                }
            } else if (currentCart.table) {
                handleUpdateCartTable(null);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentStore, currentCart, takeoutMode]);

    useEffect(() => {
        if (!cart) return;

        setCouponCode(cart.coupon_code);
        setCouponCodeApplied(cart.coupon_code);

        if (Array.isArray(cart.items) && cart.items.length === 0) {
            goToHome();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cart]);

    useEffect(() => {
        if (prepaidMethod) {
            setPrepaidList(prepaidMethod.prepaid);
            if (customerCards) {
                setIsNewCardEnabled(Boolean(prepaidMethod.prepaid.some((item:any) => item.type === METHOD_PAYMENT_TYPE_CARD_ONLINE) || customerCards.can_create_card));
            }
        }
        if (payOnDeliveryMethod) {
            setPayOnDeliveryList(payOnDeliveryMethod.pay_on_delivery);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customerCards, prepaidMethod, payOnDeliveryMethod]);

    useEffect(() => {
        if (prepaidList.length > 0) {
            setCurrentMenuMethod(MENU_PREPAID);
        } else if (payOnDeliveryList.length > 0) {
            setCurrentMenuMethod(MENU_PAY_ON_DELIVERY);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [prepaidList, payOnDeliveryList])

    const handleSetCard = (data: any) => {
        setCurrentCard(data);
        setShowRegisterCard(false);
        setShowBoxPaymentMethod(false);
    }

    const handleCopyDocument = () => {
        setCpf(user.cpf);
        handleCpf();
    }

    useEffect(() => {
        setGooglePayDataResponse(null);
        if (currentCard && paymentMethod) {
            getCustomerCards();
            setPaymentMethod((prev: any) => ({
                ...prev,
                number: currentCard?.number
            }));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentCard])

    const handleObservation = () => {
        setShowInputObservation(false)
    }

    const handleCpf = () => {
        setShowInputCpf(false);
    }

    const handleCheckOrdersOpen = () => {

        //* Forçando seleção do takeout mode
        if (!Boolean(takeoutMode) && isDinein && TokenManager.getToken()) {
            setShowTakeoutModeOptions(true);
            return;
        }

        //* Forçando seleção de mesa
        if (takeoutMode === TAKEOUT_OPTIONS_DINE_IN && !currentCart?.table && currentStore.dinein_table_enabled) {
            setShowConfirmTable(true);
            return;
        }

        //* Forçando seleção do método de pagamento
        if (!paymentMethod) {
            setShowBoxPaymentMethod(true);
            setCurrentCard(null);
            return;
        }

        checkOrdersOpen()
            .then((response) => {
                if (response.hasOrderOpen) {
                    setShowConfirmOrdersOpen(true);
                } else {
                    handleCreateOrder();
                }
            })
            .catch((error) =>
                handleCreateOrder()
            );
    }

    const handleSuccessFormProfile = () => {
        setShowFormProfile(false);
        //* criando order com base no google googlePayDataResponse
        if (googlePayDataResponse && paymentMethod?.type === METHOD_PAYMENT_TYPE_GOOGLE_PAY) {
            handleCreateOrder(googlePayDataResponse)
        }
    }

    const handleCreateOrderWithGooglePay = (googlePayResponse: GooglePayParamsProps) => {
        const hasRequiredProfileInfo = Boolean(!user.email || !user.cpf);
        if (hasRequiredProfileInfo) {
            if (!user.email) {
                const googlePayEmail = googlePayResponse.email;
                setUser({...user, email: googlePayEmail});
            }
            setGooglePayDataResponse(googlePayResponse);
            setShowFormProfile(true);
        } else {
            handleCreateOrder(googlePayResponse);
        }
    }

    const createOrderPix = (payload: any) => {
        setMainLoadingTitle(t('checkout.generating_pix_code'));
        createOrder(payload);
    }

    const createOrderCardOnline = (payload: any) => {
        setShowRegisterCard(false);
        setMainLoadingTitle(t('checkout.processing_payment'));
        const payloadUpdated = ({
            ...payload,
            ...currentCard
        });
        createOrder(payloadUpdated);
    }

    const createOrderCardDelivery = (payload: any) => {
        setMainLoadingTitle(t('checkout.processing_payment'));
        createOrder(payload);
    }

    const createOrderMoney = (payload: any) => {
        setMainLoadingTitle(t('checkout.processing_payment'));
        const payloadUpdated = ({
            ...payload,
            cash_amount: cart.total_with_discount
        });
        createOrder(payloadUpdated);
    }

    const createOrderVoucher = (payload: any) => {
        setMainLoadingTitle(t('checkout.processing_payment'));
        createOrder(payload);
    }

    const createOrderWallet = (payload: any) => {
        setMainLoadingTitle(t('checkout.processing_payment'));
        createOrder(payload);
    }

    const createOrderGooglePay = (payload: any, googlePayResponse: any) => {
        const googlePayToken = googlePayResponse ? googlePayResponse.token : null;
        const billingAddress = googlePayResponse ? googlePayResponse.billingAddress : null;
        setMainLoadingTitle(t('checkout.processing_payment'));
        if (googlePayToken) {
            const payloadUpdated = ({
                ...payload,
                google_pay_token: googlePayToken,
                billing_address: billingAddress
            });
            createOrder(payloadUpdated);
        }
    }

    const handleCreateOrder = async (googlePayResponse: GooglePayParamsProps | null = null) => {

        setGooglePayDataResponse(null);
        setShowConfirmOrdersOpen(false);

        if (!paymentMethod) {
            setMainLoading(true);
            setMainLoadingIcon(false);
            setMainLoadingIconInfo(true);
            setMainLoadingTitle(t('checkout.how_to_pay_title'));
            setMainLoadingMessage(t('checkout.how_to_pay_message'));
            setMainLoadingCloseButton(true);
        } else {
            const payload = {
                payment_method: paymentMethod.type,
                store_id: currentStore.id,
                order_type: Number(getOrderTypeIdByName(orderType)),
                cart_id: isStoreCounter ? cartDisplay.id : cart.cart_id,
                observation: observation,
                ...(isDelivery && {customer_address_id: currentAddress.id}),
                ...(isStoreCounter && {cashier_id: cashier.id}),
                ...(isStoreCounter && cartDisplay.order?.id ? { order_id: cartDisplay.order.id } : {}), //* utilizado após o cancelamento do pagamento, no segundo createOrder
                ...(paymentMethod.customer_card_id ? { customer_card_id: paymentMethod.customer_card_id } : {}), //* utilizado para pagamento com cartão salvo
                ...(isDinein && {takeout_mode: takeoutMode}),
            }

            if (paymentMethod.type === METHOD_PAYMENT_TYPE_PIX) {
                createOrderPix(payload);
            } else if (paymentMethod.type === METHOD_PAYMENT_TYPE_CARD_ONLINE) {
                createOrderCardOnline(payload);
            } else if (paymentMethod.type === METHOD_PAYMENT_TYPE_GOOGLE_PAY) {
                createOrderGooglePay(payload, googlePayResponse);
            } else if (paymentMethod.type === METHOD_PAYMENT_TYPE_CARD_DELIVERY) {
                createOrderCardDelivery(payload);
            } else if (paymentMethod.type === METHOD_PAYMENT_TYPE_MONEY) {
                createOrderMoney(payload);
            } else if (paymentMethod.type === METHOD_PAYMENT_TYPE_VOUCHER) {
                createOrderVoucher(payload);
            } else if (paymentMethod.type === METHOD_PAYMENT_TYPE_WALLET) {
                createOrderWallet(payload);
            }
        }
    }

    const createOrder = async (payload: any) => {

        setMainLoading(true);
        setMainLoadingMessage(t('checkout.processing_payment_loading'));

        try {
            const orderService = new OrderService(orderType);
            const response = await orderService.create(payload);
            const orderCreated = response.order

            if (orderCreated) {
                setOrder(orderCreated);
                setShowRegisterCard(false);
                handleChangeMethod(null);
                setMainLoading(false);
                setTakeoutMode('');

                if (!isStoreCounter) {
                    const orderTypeId = Number(getOrderTypeIdByName(orderType));
                    const payload = {
                        store_id: currentStore.id,
                        order_type_id: orderTypeId,
                        order_type: orderType
                    }
                    getActiveCart(payload).catch(() => {});
                }

                if (orderCreated.payment_method.type === METHOD_PAYMENT_TYPE_PIX && orderCreated.status === ORDER_STATUS_AWAITING_PAYMENT) {
                    goToOrderPlace(orderCreated);
                } else {
                    handleOrderFinished(orderCreated);
                }
            } else {
                //* Verificando horários de funcionamento
                storeIsOpen();
            }
        } catch (error: any) {
            setMainLoadingIcon(false);
            setMainLoadingIconError(true);
            setMainLoadingTitle(t('errors.default_title'));
            const friendlyMessage = error?.response?.data?.message;
            const errorMessage = friendlyMessage ||
                                    (isStoreCounter
                                        ? t('errors.default_message_store_counter')
                                        : t('errors.default_message')
                                    );
            setMainLoadingMessage(errorMessage);
            setMainLoadingCloseButton(true);
        }
    }

    const getCustomerCards = async () => {
        const payload = {
            store_id: currentStore.id,
        }
        try {
            const customerService = new CustomerService(orderType);
            const getCards = isStoreCounter
                    ? await customerService.getCardsStoreCounter(payload)
                    : await customerService.getCards(user.id, payload)

                if (getCards) {
                    const getCardsUpdated = getCards.cards.map((card: any) => ({
                        ...card,
                        type: METHOD_PAYMENT_TYPE_CARD_ONLINE,
                    }));
                    setCustomerCards(getCardsUpdated);
                }
            } catch (error) {
                setCustomerCards(null)
            } finally {
                setLoadingGetCards(false);
            }
    }

    const handleCancelCpf = () => {
        setShowInputCpf(false);
        setCpf('');
    }

    const handleCancelObservation = () => {
        setShowInputObservation(false)
    }

    const handleChangeMethod = (method: any) => {
        setShowRegisterCard(false);
        setCurrentCard(null);
        if (method?.type === METHOD_PAYMENT_TYPE_CARD_ONLINE) {
            const methodUpdated = {...method, customer_card_id: method.id }
            setPaymentMethod(methodUpdated);
        } else {
            setPaymentMethod(method);
        }
        setCurrentCard(null);
        setShowBoxPaymentMethod(false);
    }

    const handleOrderFinished = (order: any) => {
        setMainLoading(false);

        if (isStoreCounter) {
            cartFinished({
                id: cartDisplay.id,
                display_id: cartDisplay.display_id ? Number(cartDisplay.display_id) : null,
                order: order
            });
            goToHome();
        } else {
            goToOrderPlace(order);
        }
    }

    useEffect(() => {
        if (paymentMethod) {
            setLabelBtnPay(paymentMethod && paymentMethod.type === METHOD_PAYMENT_TYPE_PIX ? t('checkout.generate_pix_code') : t('checkout.make_payment'));
        } else {
            setLabelBtnPay(t('checkout.how_to_pay_title'));
        }
        const hasRequiredProfileInfo = Boolean(
            paymentMethod
            && paymentMethod.type !== METHOD_PAYMENT_TYPE_PIX
            && paymentMethod.type !== METHOD_PAYMENT_TYPE_GOOGLE_PAY
            && (!user?.email || !user?.cpf)
        );
        setShowFormProfile(hasRequiredProfileInfo);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paymentMethod]);

    const handleCancelFormProfile = () => {
        setShowFormProfile(false);
        setPaymentMethod(null);
        setShowRegisterCard(false);
        setGooglePayDataResponse(null);
    }

    const IconOrderType = ORDER_TYPE_ICONS[orderType as keyof typeof ORDER_TYPE_ICONS];

    const handleSelectPaymentMethod = () => {
        setTimeout(() => {
            setShowBoxPaymentMethod(true);
        }, 150);
    }

    const handleCancelRegisterCustomerCard = () => {
        setPaymentMethod(null);
        setShowRegisterCard(false);
    }

    const handleCloseRegisterCard = () => {
        setShowRegisterCard(false);
        if (!currentCard) {
            setPaymentMethod(null);
        }
    }

    useEffect(() => {
        if (takeoutMode === TAKEOUT_OPTIONS_DINE_IN && currentStore.dinein_table_enabled) {
            loadTables();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [takeoutMode]);

    if (isStoreCounter && !cartDisplay) return null;

    return (
        <>
            <section className='flex flex-col flex-grow w-full h-dvh'>
                {cart?.empty 
                    ?  <CartEmpty onCloseCart={() => handleCancel()} />
                    : 
                        <div className="relative flex flex-col gap-2 md:flex-row justify-between min-h-dvh md:min-h-full border border-transparent">
                            <section className="flex flex-col w-full md:overflow-y-auto">

                                {/* HEADER */}
                                <div className="bg-white/75 backdrop-blur-sm z-30 p-4 flex flex-col w-full sticky top-0 transition-all ease-in-out">
                                    <HeaderMinimal
                                        title={isStoreCounter ? user?.first_name : t("pages_title.checkout")}
                                        subtitle={ 
                                            isStoreCounter
                                                ? cartDisplay && (
                                                    <div className="flex gap-1">
                                                        <Badge type="title" className="text-sm md:text-xs lowercase">nº{" "}{formatCartId(cartDisplay.display_id || cartDisplay.id)}</Badge>{" "}<Badge type="title" outline className="text-sm md:text-xs gap-0.5"><MdOutlineTableRestaurant />{cartDisplay.table?.name}</Badge>
                                                    </div>
                                                ) 
                                                : currentCart && (
                                                    <div className="flex gap-1">
                                                        <Badge type="title" className="text-sm md:text-xs lowercase">nº {formatCartId(currentCart.cart_id)}</Badge>
                                                    </div>
                                                )
                                        }
                                        onCancel={() => setShowConfirmCancel(true)}
                                        loading={loadingListPaymentMethods}
                                    />
                                </div>

                                <div className="flex flex-col justify-between h-full gap-4 p-4 pt-2 mt-2 text-sm" style={{ paddingTop: boxHeightMethodPayment + 'px' }}>
                                    <section className="flex flex-col gap-2 w-full h-full md:h-max md:pb-20">

                                        {/* OrderType Info */}
                                        {(isDelivery || isDinein) &&
                                            <>
                                                {/* Takeout Mode */}
                                                <CardBoxCheckout loading={loadingListPaymentMethods}>
                                                    <div className="grid gap-2">
                                                        <div className="flex w-full self-start justify-between">
                                                            <div className="flex flex-col">
                                                                <span className="font-medium text-gray-500">{t('checkout.you_are_ordering_to')}</span>
                                                                <div className="flex items-center gap-1 text-xl font-bold leading-none text-custom-primary">
                                                                    <IconOrderType />
                                                                    { takeoutMode
                                                                        ? ORDER_TYPE_LABELS[takeoutMode as keyof typeof ORDER_TYPE_LABELS]
                                                                        : ORDER_TYPE_LABELS[orderType as keyof typeof ORDER_TYPE_LABELS]
                                                                    }
                                                                </div>
                                                            </div>
                                                            {isDinein && 
                                                                <div>
                                                                    <ButtonLink onClick={() => setShowTakeoutModeOptions(true)} className="text-xs gap-0.5 text-xs h-8">
                                                                        { t('layout.button_change_label') }
                                                                    </ButtonLink>
                                                                </div>
                                                            }
                                                        </div>

                                                        {/* TABLE */}
                                                        {isDinein && takeoutMode === TAKEOUT_OPTIONS_DINE_IN && currentStore.dinein_table_enabled &&
                                                            <>
                                                                <hr className="opacity-50" />
                                                                <CardBoxCheckoutTable />
                                                            </>
                                                        }
                                                    </div>
                                                </CardBoxCheckout>

                                            </>
                                        }

                                        {/* COUPON */}
                                        {!isStoreCounter &&
                                            <CardBoxCheckout loading={loadingListPaymentMethods} loadingOneRow loadingFull iconTop={false} icon={<TbTicket className="-rotate-45" />}>
                                                <div className="flex gap-2 items-center w-full">

                                                    <div className="flex gap-2 flex-col w-full items-center">
                                                        <div className="relative flex items-center justify-center w-full">
                                                            <IMaskInput
                                                                mask="#******************************"
                                                                definitions={{
                                                                '*': /[A-Za-z0-9-]/,
                                                                }}
                                                                radix=""
                                                                autoComplete="off"
                                                                onAccept={(value) => setCouponCode(value)}
                                                                onKeyDown={(e) => {
                                                                    if (e.key === 'Enter') {
                                                                        handleCoupon();
                                                                    }
                                                                }}
                                                                unmask={false}
                                                                name="coupon_code"
                                                                value={couponCode}
                                                                placeholder={t('checkout.coupon.placeholder')}
                                                                disabled={loadingCoupon || couponCodeApplied}
                                                                className={`
                                                                    flex w-full rounded
                                                                    border-0
                                                                    pr-24
                                                                    text-shopfood-title
                                                                    placeholder:text-gray-600
                                                                    placeholder:font-semibold
                                                                    focus:text-base
                                                                    outline-none
                                                                    transition-all ease-in-out duration-200
                                                                    ${(couponCodeApplied || loadingCoupon) ? 'bg-transparent p-1 font-bold text-base' : 'font-bold p-2.5 ring-1 ring-gray-300 focus:ring-custom-primary focus:ring-2 focus:outline-none'}
                                                                    `}
                                                                />
                                                            <button
                                                                type="button"
                                                                disabled={loadingCoupon}
                                                                onClick={handleCoupon}
                                                                className={`
                                                                    absolute text-custom-primary rounded-full p-1 pr-0 focus-visible:outline transition-width ease-in-out duration-200
                                                                    ${couponCodeApplied ? '-right-1' : 'right-2 hover:bg-gray-100'}
                                                                `}
                                                                >
                                                                {couponCodeApplied && loadingCoupon
                                                                    ?   <div className="flex items-center gap-1 text-gray-400 text-xs font-medium mr-1"><ImSpinner8 className="animate-spin" />{t('checkout.coupon.label_removing_code')}</div>
                                                                    :   loadingCoupon
                                                                            ?   <div className="flex justify-center gap-1 items-center w-20 text-gray-400 text-xs font-medium mr-1"><ImSpinner8 className="animate-spin" />{t('checkout.coupon.label_applying_code')}</div>
                                                                            :   couponCodeApplied
                                                                                    ?  <Badge outline type="custom" className="rounded-full justify-center h-6 w-20 zoomInIconNoDelay text-xs capitalize">{t('checkout.coupon.button_remove_label')}</Badge>
                                                                                    :   isValidCouponCode && <Badge type='custom' className="rounded-full justify-center h-6 w-20 fadeInIcon text-xs capitalize">{t('checkout.coupon.button_apply_label')}</Badge>
                                                                }
                                                            </button>
                                                        </div>

                                                    </div>
                                                </div>
                                            </CardBoxCheckout>
                                        }

                                        {/* DELIVERY ADDRESS */}
                                        {(isDelivery && currentAddress) &&
                                            <CardBoxCheckout icon={<TbMapPin />} loading={loadingListPaymentMethods}>
                                                <div className="grid gap-2">
                                                    <div className="flex gap-3 items-center w-full self-start">
                                                        <div className="flex flex-col gap-0.5 w-full">
                                                            <span className="font-medium text-custom-primary">{t('checkout.delivery_address_title')}</span>
                                                            <span className="font-medium leading-none text-shopfood-title">
                                                                {currentAddress.title && <span className="font-bold">{ currentAddress.title }: </span>}
                                                                { formatCurrentAddress(currentAddress) }
                                                            </span>
                                                        </div>
                                                    </div>
                                                    {currentStore.shipping_time &&
                                                        <section className="flex gap-0.5 items-center text-xs leading-none">
                                                            <div><TbClock /></div>
                                                            <span>{t('checkout.shipping_time.estimate')}: <span className="font-semibold">{ currentStore.shipping_time } {t('checkout.shipping_time.minutes')}</span></span>
                                                        </section>
                                                    }
                                                </div>
                                            </CardBoxCheckout>
                                        }

                                        {/* STORE */}
                                        {(currentStore && !isStoreCounter) &&
                                            <CardBoxCheckout icon={<TbBuildingSkyscraper />} loading={loadingListPaymentMethods}>
                                                <div className="flex gap-2 items-center w-full">
                                                    <div className="flex flex-col w-full">
                                                        <span className="flex items-center justify-between text-gray-400">
                                                            <span>{t('layout.store_name')}</span>
                                                            <button onClick={() => setShowStoreAddress(!showStoreAddress)} className="inline-flex items-center gap-0.5 text-xs font-medium mr-2">
                                                                {showStoreAddress ? <>{t('checkout.hide_address')}</> : <>{t('checkout.show_address')}</> }
                                                            </button>
                                                        </span>
                                                        <span className="font-semibold flex justify-between gap-2">
                                                            {currentStore.name}
                                                        </span>
                                                        <div className={`transition-all ease-in-out duration-200 text-gray-500 leading-none mt-0.5 ${showStoreAddress ? 'opacity-100 h-auto' : 'opacity-0 h-0'}`}>{ formatAddressStore(currentStore) }</div>
                                                    </div>
                                                </div>
                                            </CardBoxCheckout>
                                        }

                                        {/* CPF */}
                                        <CardBoxCheckout icon={<TbId />} loading={loadingListPaymentMethods} loadingButton>
                                            <div className="flex gap-2 items-center w-full">
                                                <div className="flex flex-col w-full">
                                                    <span className="text-gray-400">{t('checkout.document_on_the_invoice')}</span>
                                                    {!showInputCpf && <span className="font-semibold">{cpf ? formatCpf(cpf) : t('layout.not_filled_in_message')}</span> }

                                                    {(showInputCpf) &&
                                                        <div className="flex gap-2 flex-col w-full">
                                                            <div className="relative flex items-center justify-center w-full">
                                                                <IMaskInput
                                                                    mask="000.000.000-00"
                                                                    radix=""
                                                                    inputMode="numeric"
                                                                    onAccept={(value) => setCpf(value)}
                                                                    unmask={true} // true|false|'typed'
                                                                    name="cpf"
                                                                    value={cpf}
                                                                    placeholder={t('layout.label_optional')}
                                                                    className="
                                                                        flex w-full rounded
                                                                        border-0
                                                                        mt-0.5
                                                                        p-2.5 pr-28
                                                                        font-extrabold
                                                                        placeholder:text-gray-300
                                                                        placeholder:font-normal
                                                                        ring-1 ring-gray-300
                                                                        outline-none
                                                                        focus:ring-custom-primary
                                                                        focus:ring-2
                                                                        focus:outline-none
                                                                        transition-all ease-in-out duration-200"
                                                                />
                                                                {cpf && !isCpfValid(cpf)
                                                                    ?  <span className="absolute right-2 text-xs font-medium text-shopfood-error">{t('form.validation.invalid')}</span>
                                                                    :  cpf
                                                                        ? <HiXMark size={22} onClick={() => setCpf('')} className='absolute cursor-pointer p-1 right-2 bg-gray-100 hover:bg-gray-200 rounded-full' />
                                                                        : user.cpf && <ButtonLink onClick={handleCopyDocument} className="absolute right-2 text-xs font-medium h-8">{t('checkout.use_my_document')}</ButtonLink>
                                                                }
                                                            </div>
                                                            <div className="flex gap-1.5 text-xs">
                                                                <ButtonLink outline onClick={handleCpf} disabled={!isCpfValid(cpf)} className="h-8">{t('layout.button_add_label')}</ButtonLink>
                                                                <Button onClick={handleCancelCpf} className='h-8'>{t('layout.confirm.cancel')}</Button>
                                                            </div>
                                                        </div>
                                                    }
                                                </div>

                                                {!showInputCpf &&
                                                    <ButtonLink onClick={() => setShowInputCpf(true)} className="text-xs gap-0.5 text-xs h-8">
                                                        {!cpf ? t('layout.button_add_label') : t('layout.button_change_label') }
                                                    </ButtonLink>
                                                }
                                            </div>
                                        </CardBoxCheckout>

                                        {/* OBSERVACAO */}
                                        {(!isStoreCounter) &&
                                            <CardBoxCheckout icon={<TbMessage />} loading={loadingListPaymentMethods} loadingButton>
                                                <div className="flex gap-2 items-center w-full">

                                                    <div className="flex flex-col w-full">
                                                        <span className="text-gray-400">{t('layout.observation.title')}</span>
                                                        {!showInputObservation && <span className="font-semibold">{observation ? observation : t('layout.observation.none')}</span> }

                                                        {(showInputObservation) &&
                                                            <div className="flex gap-2 flex-col w-full">
                                                                <textarea
                                                                    onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setObservation(e.target.value)}
                                                                    name="observation"
                                                                    value={observation}
                                                                    placeholder={t('checkout.observation.placeholder')}
                                                                    className={`
                                                                        block w-full rounded-md border-0 p-2.5 shadow ring-1 ring-gray-300
                                                                        placeholder:text-gray-300
                                                                        focus:ring-2 focus:ring-custom-primary
                                                                        transition-all ease-in-out duration-500
                                                                        ${observation ? 'h-24' : 'h-14'}
                                                                        focus:h-24
                                                                    `}
                                                                />
                                                                <div className="flex gap-1.5 text-xs">
                                                                    <ButtonLink outline onClick={handleObservation} disabled={!observation} className="h-8">{t('layout.button_add_label')}</ButtonLink>
                                                                    <Button onClick={handleCancelObservation} className='self-start h-8'>{t('layout.confirm.cancel')}</Button>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>

                                                    {!showInputObservation &&
                                                        <ButtonLink onClick={() => setShowInputObservation(true)} className="text-xs gap-0.5 text-xs h-8">
                                                            {!observation ? t('layout.button_add_label') : t('layout.button_change_label') }
                                                        </ButtonLink>
                                                    }
                                                </div>
                                            </CardBoxCheckout>
                                        }

                                    </section>
                                </div>

                                <div className="hidden md:flex md:flex-col sticky bottom-0 gap-2 p-4 w-full justify-end bg-white/75 backdrop-blur-sm">
                                    <section className="py-2">
                                        <CardBoxCheckoutMethod
                                            onSelectMethod={handleSelectPaymentMethod}
                                            loading={loadingListPaymentMethods}
                                            method={paymentMethod}
                                            currentMenuMethod={currentMenuMethod}
                                        />
                                    </section>

                                    <div className="flex justify-between gap-2 w-full">
                                        <ButtonsCheckout
                                            label={labelBtnPay}
                                            disabledFinish={cart?.total === 0 || cart?.empty || loadingListPaymentMethods || loadingCoupon}
                                            onFinishOrder={handleCheckOrdersOpen}
                                            onCancel={() => setShowConfirmCancel(true)}
                                            method={paymentMethod}

                                            isGooglePay={paymentMethod && paymentMethod.type === METHOD_PAYMENT_TYPE_GOOGLE_PAY}
                                            onCreateOrderWithGooglePay={(e: GooglePayParamsProps) => handleCreateOrderWithGooglePay(e)}
                                            onCancelGooglePay={(e: any) => handleChangeMethod(e)}
                                            cart={cart}
                                        />
                                    </div>
                                </div>

                            </section>

                            <section className="h-full w-full md:max-w-md md:shadow-xl md:shadow-gray-100 px-2 md:px-0 md:py-4">
                                <Cart
                                    onCloseCart={() => handleCancel()}
                                    onCartInfo={(e: any) => setCart(e)}
                                    getCart={cart ?? null}
                                    onlyInfo
                                    enablePolling
                                    showButtonEditCart
                                />
                            </section>

                            <section className="sticky bottom-18 md:hidden pt-2 pl-6 pr-4 bg-white/75 backdrop-blur-sm border-t border-gray-100">
                                <CardBoxCheckoutMethod
                                    onSelectMethod={handleSelectPaymentMethod}
                                    loading={loadingListPaymentMethods}
                                    method={paymentMethod}
                                    currentMenuMethod={currentMenuMethod}
                                />
                            </section>

                            <div className="absolute w-full flex items-center md:hidden sticky bottom-0 p-4 gap-2 w-full bg-white/75 backdrop-blur-sm">
                                <ButtonsCheckout
                                    label={labelBtnPay}
                                    disabledFinish={cart?.total === 0 || cart?.empty || loadingListPaymentMethods || loadingCoupon}
                                    onFinishOrder={handleCheckOrdersOpen}
                                    onCancel={() => setShowConfirmCancel(true)}
                                    method={paymentMethod}

                                    isGooglePay={paymentMethod && paymentMethod.type === METHOD_PAYMENT_TYPE_GOOGLE_PAY}
                                    onCreateOrderWithGooglePay={(e: GooglePayParamsProps) => handleCreateOrderWithGooglePay(e)}
                                    onCancelGooglePay={(e: any) => handleChangeMethod(e)}
                                    cart={cart}
                                />
                            </div>
                        </div>
                }
            </section>

            {/* Confirm cancel */}
            <Modal open={showConfirmCancel} className="max-w-sm m-4" onClose={() => setShowConfirmCancel(false)}>
                <Confirm
                    title={t('checkout.cancel.title')}
                    message={t('checkout.cancel.message')}
                    labelConfirm={t('checkout.cancel.label_confirm')}
                    onConfirm={() => handleCancel()}
                    onCancel={() => setShowConfirmCancel(false)}
                />
            </Modal>

            {/* Confirm continue (orders open) */}
            <Modal open={showConfirmOrdersOpen} className="max-w-sm m-4" onClose={() => setShowConfirmOrdersOpen(false)}>
                <Confirm
                    icon={CONFIRM_ICON_INVOICE}
                    title={t('checkout.orders_open.title')}
                    message={t('checkout.orders_open.message')}
                    labelConfirm={t('checkout.orders_open.label_confirm')}
                    onConfirm={handleCreateOrder}
                    onCancel={() => setShowConfirmOrdersOpen(false)}
                />
            </Modal>

            {/* Update profile */}
            <Drawer
                open={showFormProfile}
                title={t('checkout.complete_profile.title_drawer')}
                onClose={handleCancelFormProfile}
                className='md:max-w-sm ml-2'
                >
                <FormProfileCheckout
                    title={t('checkout.complete_profile.title')}
                    onSuccess={handleSuccessFormProfile}
                    onCancel={handleCancelFormProfile}
                    buttonLabel={t('checkout.complete_profile.button_submit.label')}
                />
            </Drawer>

            {/* Payment methods */}
            <Drawer
                open={showBoxPaymentMethod}
                title={t('checkout.how_to_pay_title')}
                onClose={() => setShowBoxPaymentMethod(false)}
                className='md:max-w-sm ml-2 bg-gray-100'
                classNameChildren={'bg-gray-50 border-t border-gray-100'}
            >
                <PaymentMethods
                    cart={cart}
                    prepaidList={prepaidList}
                    payOnDeliveryList={payOnDeliveryList}
                    customerCards={customerCards}
                    onChangeMethod={(e: any) => handleChangeMethod(e)}
                    loading={loadingListPaymentMethods || loadingGetCards}
                    isNewCardEnabled={isNewCardEnabled}
                />
            </Drawer>

            {/* Form register customer card */}
            <Drawer
                open={showRegisterCard && !showFormProfile}
                title={t('checkout.form_register_customer_card.title')}
                subtitle={t('checkout.form_register_customer_card.subtitle')}
                onClose={handleCloseRegisterCard}
                className='md:max-w-sm ml-2'
            >
                <FormRegisterCustomerCard
                    onCancel={handleCancelRegisterCustomerCard}
                    onSetCard={handleSetCard}
                />
            </Drawer>

        </>
    )
}

export default Checkout;